// eslint-disable-next-line @typescript-eslint/no-extraneous-class
export class GoToPage {
    public static readonly App = (redirectUri: string): void => GoToPage._redirectTo(redirectUri === '' ? `${window.location.origin}/app/` : redirectUri)

    private static readonly _redirectTo = (appUrl: string): void => {
        window.location.href = appUrl
    }
}
